import { gql } from '@apollo/client'

export const GET_ACTIVE_PRIVACY_DOCUMENT = gql`
  query GetActivePrivacyDocument($version: String) {
    activePrivacyDocument(version: $version) {
      document_id
      version
      file_url
    }
  }
`;
